import { Box, Link } from '@chakra-ui/react'

export const PageBackLink = ({ pageBack }) => (
  <Box textAlign="center" py={8}>
    <Link href="#" fontSize="xs" onClick={pageBack}>
      {'前のページへ戻る'}
    </Link>
  </Box>
)
